// Common form options
export const YES_NO_OPTIONS = [
  { value: "YES", label: "YES" },
  { value: "NO", label: "NO" },
];

export const AVAILABILITY_OPTIONS = [
  { value: "Available", label: "Available" },
  { value: "Not Available", label: "Not Available" },
];

// Form validation rules
export const REQUIRED_FIELDS = [
  "name",
  "city",
  "address",
  "email",
  "mobile",
  "superintendent_name",
  "medical_coordinator",
  "nabh_accredited",
  "total_beds",
  "bank_name",
  "account_number",
  "ifsc_code",
];

// Email validation regex
export const EMAIL_REGEX = /\S+@\S+\.\S+/;

// Phone validation regex
export const PHONE_REGEX = /^\d{10}$/;

// Google reCAPTCHA Site Key
// Replace with your actual reCAPTCHA site key from https://www.google.com/recaptcha/admin
export const RECAPTCHA_SITE_KEY =
  process.env.REACT_APP_RECAPTCHA_SITE_KEY ||
  "6LdIsAcsAAAAAHfsBGQTbKpfqAuOikMK5CNuIdb_";
